import * as Data from './data';
import { DateTime } from "luxon";

let mutations, countries, overlappingMutationsToggle, date, isWeekly;

export function showDialog(_mutations, _countries, _overlappingMutationsToggle, _date, _isWeekly, xCoord, yCoord) {

  mutations = _mutations;
  countries = _countries;
  overlappingMutationsToggle = _overlappingMutationsToggle;
  date = _date;
  isWeekly = _isWeekly;

  let container = document.querySelector("#export");
  container.classList.toggle("show", true);
  container.querySelector("#export-date").innerHTML = date.toISODate();

  container.style.left = `${ xCoord + 30 }px`;
  container.style.top  = `${ yCoord - 30 }px`;

}
export function hideDialog() {
  let container = document.querySelector("#export");
  container.classList.toggle("show", false);
}

export function addEvents() {
  document.querySelector("#export-lineages-for-mutations").addEventListener("click", e => {
    e.preventDefault();
    exportLineagesForMutations();

    let container = document.querySelector("#export");
    container.classList.toggle("export-loading", true);
    setTimeout(() => {
      container.classList.toggle("export-loading", false);
      hideDialog();
    }, 2500);
  });
  document.querySelector("#export-accessions-for-mutations").addEventListener("click", e => {
    e.preventDefault();
    exportAccessionIdsForMutations();

    let container = document.querySelector("#export");
    container.classList.toggle("export-loading", true);
    setTimeout(() => {
      container.classList.toggle("export-loading", false);
      hideDialog();
    }, 2500);
  });
}

export function exportLineagesForMutations() {

  // alert(`${mutations  },${  date.toISODate()}`);

  Data.loadMutationsDataWithLineageBreakdown(mutations, countries, overlappingMutationsToggle,
    (data) => {

      data.forEach(l => {

        if (isWeekly) {

          l.dataAtDate = {};

          // We already know the incoming date is adjusted for weeks, so math here is easy
          let startDate = date.plus({days:0});
          for (let x = 0; x < 7; x++) {
            startDate = startDate.plus({days:1});
            // console.log(startDate.toISODate());
            // console.log(l.data[startDate.toISODate()]);
            // l.dataAtDate = [...l.dataAtDate, ...l.data[startDate.toISODate()]];

            let dataAtDate = l.data[startDate.toISODate()];
            for (const mut in dataAtDate) {

              l.dataAtDate[mut] = l.dataAtDate[mut] || {};
              for (const lineage in dataAtDate[mut]) {

                if (!l.dataAtDate[mut][lineage]) {
                  l.dataAtDate[mut][lineage] = 0;
                }
                l.dataAtDate[mut][lineage] += dataAtDate[mut][lineage];

              }

            }
          }
        } else {
          l.dataAtDate = l.data[date.toISODate()];
        }


        l.date = date;
      });

      let headerColumns = [
        "Date",
        "Frequency",
        "Location",
        "Mutation",
        "Lineage",
        "Genomes"
      ];

      let csvRows = [];


      data.forEach(l => {

        let dt = l.date.toISODate();

        for (const mutation in l.dataAtDate) {

          if (mutations.find(m => m === mutation)) { // Needs to be in the original list, not just a same-site

            let rowData = [];

            for (const lineage in l.dataAtDate[mutation]) {

              let count = l.dataAtDate[mutation][lineage];

              rowData.push({
                date: dt,
                freq: isWeekly ? "weekly" : "daily",
                location: l.location,
                mutation: mutation,
                lineage : lineage,
                count   : count
              });

            }

            rowData.sort((a, b) => b.count - a.count);

            rowData.forEach(r => {
              let row = [
                r.date,
                r.freq,
                r.location,
                r.mutation,
                r.lineage,
                r.count
              ];

              csvRows.push(row.join(','));

            });

          }

        }

      });


      let headerString = headerColumns.join(',');
      csvRows.unshift(headerString);

      csvRows = csvRows.map(r => encodeURIComponent(r)); // Make sure spaces and other special characters surving the href/data uri

      let csvString = csvRows.join("%0A"); // join the rows all together and make a big giant URL

      let downloadBtn = document.createElement('a');

      let now = DateTime.now().toISODate();

      downloadBtn.classList.toggle("hidden", true);
      downloadBtn.setAttribute('href', `data:attachment/csv,${  csvString}`);
      downloadBtn.setAttribute('target','_blank')
      downloadBtn.setAttribute('download', `banyan_crosscut_lineages_for_mutations_${ mutations.join(',') }_${ countries.join(',') }_${ date.toISODate() }.csv`);

      document.body.appendChild(downloadBtn);
      downloadBtn.click();

    },
    (err) => {
      console.log('err', err);
      hideDialog();
    }
  );

}

export function exportAccessionIdsForMutations() {

  Data.loadMutationsDataWithAccessionIds(date, isWeekly, mutations, countries, overlappingMutationsToggle,
    (data) => {

      data.forEach(l => {
        l.date = date;
      });

      let headerColumns = [
        "Date",
        "Frequency",
        "Location",
        "Mutation",
        "AccessionID",
        "AttributionURL"
      ];

      let csvRows = [];

      data.forEach(l => {

        let dt = l.date.toISODate();

        for (const mutation in l.data) {

          if (mutations.find(m => m === mutation)) { // Needs to be in the original list, not just a same-site

            let rowData = [];

            l.data[mutation].forEach(accession => {

              let id = accession.id;
              let url = accession.attribution_url;

              let row = [
                dt,
                isWeekly ? "weekly" : "daily",
                l.location,
                mutation,
                id,
                url
              ];
              csvRows.push(row.join(','));

            });

          }

        }

      });

      let headerString = headerColumns.join(',');
      csvRows.unshift(headerString);

      csvRows = csvRows.map(r => encodeURIComponent(r)); // Make sure spaces and other special characters surving the href/data uri

      let csvString = csvRows.join("%0A"); // join the rows all together and make a big giant URL

      let downloadBtn = document.createElement('a');

      let now = DateTime.now().toISODate();

      downloadBtn.classList.toggle("hidden", true);
      downloadBtn.setAttribute('href', `data:attachment/csv,${  csvString}`);
      downloadBtn.setAttribute('target','_blank')
      downloadBtn.setAttribute('download', `banyan_crosscut_accessions_for_mutations_${ mutations.join(',') }_${ countries.join(',') }_${ date.toISODate() }.csv`);

      document.body.appendChild(downloadBtn);
      downloadBtn.click();


    },
    (err) => {
      console.log('err', err);
      hideDialog();
    }
  );

}